import { Flex, Paper, Space, Text, TextInput } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import RenderModal from './modal';
import DataTable from '../../components/elements/DataTable';
import styles from './styles.scoped.css';
import IconPencil from '../../components/icons/IconPencil';
import IconTrash from '../../components/icons/IconTrash';
import IconAdd from '../../components/icons/IconAdd';
import { AppContext } from '../../contexts';
import Button from '../../components/elements/Button';
import { useDispatch, useSelector } from 'react-redux';
import { clearRedux, fetchListBusinessType, postAddBusinessType } from './actions';
import { useDebounce } from '../../utils/hooks';

function SettingBusinessType() {
  const dispatch = useDispatch();
  const { dataBusinessType: { data, meta },
    isLoadingBusinessType,
    dataSubmitAddBusinessType,
    isLoadingSubmitAddBusinessType,
    messageSubmitAddBusinessType,
    dataUpdateBusinessType,
    dataDeleteBusinessType,
    messageUpdateBusinessType,
    isLoadingUpdateBusinessType
  } = useSelector(s => s.settingBusinessType);

  const { setBreadcrumbs } = useContext(AppContext);
  const [modal, setModal] = useState({
    variant: '',
    opened: false,
  });
  const [payload, setPayload] = useState({
    id: '',
    name: ''
  });
  const [editName, setEditName] = useState(payload?.name || '');

  useEffect(() => {
    if(dataSubmitAddBusinessType, isLoadingSubmitAddBusinessType, messageSubmitAddBusinessType){
      if(dataSubmitAddBusinessType?.success){
        setModal({
          variant: 'add',
          opened: false,
        });
        const { failedTotal, successTotal } = dataSubmitAddBusinessType?.data ||
         { failedTotal: 0, successTotal: 0 };
        if(failedTotal > 0 && successTotal > 0){
          setModal({
            variant: 'reason',
            opened: true,
          });
        }
        // dispatch(clearRedux('SubmitAddBusinessType'));
      }
    }
  }, [dataSubmitAddBusinessType, isLoadingSubmitAddBusinessType, messageSubmitAddBusinessType]);

  const handleSubmit = async (data) => {
    if (data.type === '1') {
      dispatch(postAddBusinessType({ name: data.name, kbli: data.codeKbli, kbliVersion: data.kbliVersion, description: data.description }, '1'));
    } else {
      const formData = new FormData();
      formData.append('file', data.file[0]);
      dispatch(postAddBusinessType(formData, '2'));
    }
  };
  const [searchValue, setSearch] = useState('');
  const [params, setParams] = useState({
    size: 100,
    page: 1
  });
  const debounceSearch = useDebounce(searchValue, 500);

  useEffect(() => {
    setBreadcrumbs(['Jenis Usaha']);
  }, []);

  const handleCloseModal = () => {
    dispatch(clearRedux('SubmitAddBusinessType'));
    setModal({
      variant: modal.variant,
      opened: false,
    });
  };

  const handleReset = () => {
    dispatch(clearRedux('SubmitAddBusinessType'));
  };

  useEffect(() => {
    dispatch(fetchListBusinessType(params,debounceSearch));
  },[debounceSearch,dataDeleteBusinessType,
    dataSubmitAddBusinessType, dataUpdateBusinessType, params]);

  useEffect(() => {
    if(dataUpdateBusinessType.success){
      setModal({
        variant: modal.variant,
        opened: false
      });
    }
  }, [isLoadingUpdateBusinessType]);

  const renderActionDisplay = (value) => {
    return (
      <Flex className={styles.actionContainer} gap="md">
        <Button
          className={styles.btnActionTable}
          onClick={() => {
            setModal({
              variant: 'edit',
              opened: true
            });
            setPayload(value);
            setEditName(value.name);
            dispatch(clearRedux('UpdateBusinessType'));
          }}
          size={'small'}
          // title={'Edit'}
        >
          <IconPencil style={{ fill: 'white' }} />
          Ubah
        </Button>
        <Button
          className={styles.btnActionTable}
          onClick={() => {
            setModal({
              variant: 'delete',
              opened: true
            });
            setPayload(value);
          }}
          size={'small'}
          style="danger"
        >
          <IconTrash style={{ fill: 'white' }} />
          Hapus
        </Button>
      </Flex>
    );
  };

  const column = [
    { heading: 'Versi', value: 'kbliVersion', className: '' },
    { heading: 'Kode KBLI', value: 'kbli', className: '' },
    { heading: 'Jenis Usaha', value: 'name', className: '' },
    { heading: 'Deskripsi', value: 'description', className: '' },
    {
      heading: 'Action',
      value: (value) => renderActionDisplay(value),
      className: 'actionColumn',
    },
  ];

  return (
    <>
      <Paper bg={'#FFF'} mb="md" p="md">
        <Flex gap="md" justify="space-between" wrap="wrap">
          <Flex align="center" gap="md">
            <Button
              className={styles.btnAdd}
              onClick={() => setModal({ variant: 'add', opened: true })}
            >
              <IconAdd /> Tambah Jenis Usaha
            </Button>
            <Text>
              Menampilkan <b>{meta.totalData}</b> data
            </Text>
          </Flex>
          <TextInput icon={<img alt="icon-text-field" src="assets/ic-search.svg"/>} onChange={(e) => {
            setSearch(e.currentTarget.value);
            if(e.currentTarget.value.length === 1){
              setParams({
                page: 1,
                size: params.size
              });
            }
          }} placeholder="Cari data..." rightSection={<Text fz={14} onClick={() => setSearch('')}>Hapus</Text>} rightSectionProps={{
            style: {
              width: '5rem',
              cursor: 'pointer'
            }
          }} styles={{
            input: {
              paddingRight: '4rem'
            }
          }} value={searchValue} width={350} />
        </Flex>
      </Paper>
      <Paper bg={'#FFF'} className={data.length < 1 && styles.emptyPaper} p="md">
        {data.length > 0 && <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={500}
            loading={isLoadingBusinessType}
            meta={{ ...meta, lastDataAt: new Date(), loadedAt: new Date() }}
            onEndReached={() => setParams({ ...params, page: params.page + 1 })}
            withIndex
          />
        </div>}
        {data.length < 1 && !isLoadingBusinessType && <div className={styles.containerEmpty}>
          <img src="../../assets/ic_notfound.svg"/>
          <div>
            <Text fw={500} fz={24}>Belum ada jenis usaha</Text>
            <Text c="#52575C" fz={18}>Tambahkan jenis usaha yang bisa didaftarkan usaha mikro berdasarkan data KBLI.</Text>
            <Space h={'2dvh'}/>
            <Button className={styles.btnAdd} onClick={() => setModal({ variant: 'add', opened: true })} outlined><IconAdd /> Tambah Jenis Usaha</Button>
          </div>
        </div>}
      </Paper>
      <RenderModal
        dataBusinessType={payload}
        dataSubmitAddBusinessType={dataSubmitAddBusinessType}
        editName={editName}
        errorEditBusinessType={messageUpdateBusinessType}
        handleCloseModal={handleCloseModal}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        opened={modal.opened}
        setEditName={setEditName}
        variant={modal.variant}
      />
    </>
  );
}

export default SettingBusinessType;
